const cn = {
  index: {
    avatamsaka: '大方广佛华严经',
    webContra: '藏汉比对',
    cateList: '经书列表',
    aboutContrast: '关于藏汉比对',
    aboutTeam: '关于我们',
  },
};

export default cn;



// WEBPACK FOOTER //
// ./src/i18n/langs/cn/homepage.js